import { useMutation } from 'react-query';
import editRoomTenant from '../requests/editRoomTenant';

const useEditRoomTenantMutation = (options) =>
  useMutation(({ values }) => editRoomTenant(values), options);

export default useEditRoomTenantMutation;
